import React from 'react';
import styled from '@emotion/styled';
import { useParams } from 'react-router-dom';
import { useEditProduct } from './useEditProduct';
import { DeleteButton, Form, FormGrid, OccupyFreeSpace, SaveButton, TabPanel, TabsHeader, TitleLink, useSaveable, useTabsState } from '../../../toolympus/components/primitives';
import { Divider, IconButton } from '@mui/material';
import { DeleteOutlined } from '@mui/icons-material';
import { useItemWithControls } from '../../../toolympus/api/useWithControls';
import { MediaLibProvider } from '../../../toolympus/components/medialib';
import { ProductSubmissionsList } from './ProductSubmissionsList';
import { FormControlsForFields } from '../../../toolympus/components/schemed';
import { FormFieldsEditor } from '../../../toolympus/components/ConfigurableForms/FormFieldsEditor';
import { useEditFormFieldsBasic } from '../../../toolympus/components/ConfigurableForms/useEditConfigurableForm';

interface Props {
  
}



export const FocusControlsPanel = styled(FormGrid)`
  border-radius: 16px;
  background: #c7dc4130;
  padding: 12px;
  box-shadow: ${props => props.theme.shadows[2]};
`;
FocusControlsPanel.defaultProps = { columns: "1fr", noMargin: true };


export const ProductEditPage = (props: Props) => {
  const { id } = useParams<{ id: string }>();
  const data = useEditProduct(id);

  const { controls } = useItemWithControls(data, { schema: data.schema });
  // const user = useUser();

  useSaveable(data);

  const fieldsData = useEditFormFieldsBasic(data);

  
  const tabs = useTabsState([
    ["attributes","Attributes"],
    ["fields", "Fields"],
    ["registrations","Submissions"],
    // ["discount_codes","Discount Codes"],
  ], "attributes", "tab");


  return (
    <MediaLibProvider apiPath="/api/media" spaceId={"paymentform"} urlPrefix="/media">
      <Form
        title={<TitleLink to="/products">Product</TitleLink>}
        headerItems={<>
          <OccupyFreeSpace />
          {data.hasChanges && <SaveButton action={() => data.save()} />}

          <DeleteButton
            remove={() => data.remove()}
            title="Remove product?"
            button={<IconButton size="small"><DeleteOutlined /></IconButton>}
            />
        </>}
        >
        <FormGrid columns="3fr 1fr" style={{ alignItems: "flex-end" }}>
          {controls([
            ["title"],
            ["is_active"],
          ])}

          
        </FormGrid>

        <TabsHeader state={tabs} />

        <TabPanel state={tabs.forTab("attributes")}>
          <FormGrid columns="2fr 1fr" forceEvenColumns>
            <FormGrid columns="1fr" noMargin>
              

              <FormGrid columns="repeat(3,1fr)">
                {controls([
                  ["created_at", { disabled: true, utcToLocal: true }],
                  ["updated_at", { disabled: true, utcToLocal: true }],
                  ["created_by", { disabled: true }],
                  ["updated_by", { disabled: true }],
                ])}
              </FormGrid>
            </FormGrid>

            <FormGrid columns="1fr" noMargin>
              <FocusControlsPanel columns="1fr" noMargin>
                {controls([
                  ["price"],
                  ["processing_title"],
                  ["receipt_title"],
                  ["payment_tax_option"],
                ])}

              </FocusControlsPanel>

              
            </FormGrid>
          </FormGrid>



          
        </TabPanel>

        

        <TabPanel state={tabs.forTab("registrations")}>
          <ProductSubmissionsList product={data.data} isPaid />
        </TabPanel>

        <TabPanel state={tabs.forTab("fields")}>
          <FormGrid columns="1fr">
            <FormControlsForFields
              fields={[
                ["display_name_format"],
              ]}
              schema={data.schema}
              data={data.data}
              onChange={(o,c) => data.update(c)}
              />

            <div />

            <Divider />

            <FormFieldsEditor
              data={fieldsData}
              // customFieldTypes={CustomFieldTypes}
              noRegexes
              allowSubtypes
              />

          </FormGrid>
        </TabPanel>
      </Form>
    </MediaLibProvider>
  );
}
